import { Badge } from "@shopify/polaris";
import React from "react";

function InsuranceStatusBadge({ status }) {
  if (!status) return;
  switch (status) {
    case "cancelled":
      return <Badge tone="">Cancelada</Badge>;
    case "expired":
      return <Badge tone="critical">Expirada</Badge>;
    case "active":
      return <Badge tone="success">Activa</Badge>;
    case "temporary":
      return <Badge tone="attention">Temporal</Badge>;
    default:
      return <Badge>NA</Badge>;
  }
}

export default InsuranceStatusBadge;
